const { JOB_ROOM, WORKSTATION_ROOM } = require("../rooms/RoomNameConstants")
const { default: store } = require("../store/store")

export const getClaraIntent = () => {
    let message
    const jobInfo = {}
    const state = store.getState()

    const currentRoom = state.room.history[0].ID
    const selectedJob = state[currentRoom].selectedJob
    const selectedWorkstation = state[currentRoom].selectedWorkstation

    console.log(currentRoom);

    switch (currentRoom) {
        case JOB_ROOM:
            jobInfo["job"] = selectedJob.name
            jobInfo["workstation"] = selectedJob.workstation.name
            jobInfo["jobstream"] = selectedJob.jsName
            jobInfo["start_time"] = new Date(selectedJob.scheduledTime).toISOString()
            message = "/job_status" + JSON.stringify(jobInfo)
            break;
        case WORKSTATION_ROOM:
            jobInfo["workstation"] = selectedWorkstation.name
            message = "/workstation_status" + JSON.stringify(jobInfo)
            break;
        default:
            message = "/welcome"
            break;
    }

    console.log(message);

    return message
}